import { render, staticRenderFns } from "./dxOrderList.vue?vue&type=template&id=52fbebca&scoped=true&"
import script from "./dxOrderList.vue?vue&type=script&lang=js&"
export * from "./dxOrderList.vue?vue&type=script&lang=js&"
import style0 from "./dxOrderList.vue?vue&type=style&index=0&id=52fbebca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fbebca",
  null
  
)

export default component.exports